const fixDateForAllBrowsers = (dateString) => dateString.replace(/-/g, '/')

const getMostRecentOrder = (orders) => {
  if (!orders) {
    return null
  }

  const dateNow = Date.now()

  const mostRecentOrderReduced = orders.reduce((mostRecentOrder, currentOrder) => {
    const mostRecentOrderDeliveryDate = new Date(
      fixDateForAllBrowsers(mostRecentOrder.delivery_date),
    )
    const currentOrderDeliveryDate = new Date(
      fixDateForAllBrowsers(currentOrder.delivery_date),
    )
    const timeFromMostRecentOrder = mostRecentOrderDeliveryDate.getTime() - dateNow
    const timeFromCurrentOrder = currentOrderDeliveryDate.getTime() - dateNow

    if (currentOrderDeliveryDate.getTime() > dateNow) {
      return mostRecentOrder
    }

    if (timeFromMostRecentOrder < timeFromCurrentOrder) {
      return currentOrder
    }

    return mostRecentOrder
  })

  const mostRecentOrderReducedDeliveryDate = new Date(
    fixDateForAllBrowsers(mostRecentOrderReduced.delivery_date),
  )

  if (mostRecentOrderReducedDeliveryDate.getTime() > dateNow) {
    return null
  }

  return mostRecentOrderReduced
}

export { getMostRecentOrder, fixDateForAllBrowsers }
